import { CurrencyEnum, PaymentMethodEnum } from '@systemeio/ui'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import useSWR from 'swr'
import useUser from 'shared/hooks/use-user'
import { baseFetcher } from 'shared/utils/http-client'

export function usePaymentMethods(currentCurrency?: CurrencyEnum, isFetchAllowed = true) {
  const { user } = useUser()

  return useControlledSwr<{
    paymentMethods: PaymentMethodEnum[]
  }>(
    () => {
      if (user && currentCurrency) {
        return `/api/dashboard/customer/payment-methods/${currentCurrency}`
      }
      return null
    },
    baseFetcher,
    undefined,
    isFetchAllowed,
  )
}

export function usePaymentMethodsForCurrencies(currencies?: CurrencyEnum[], isFetchAllowed = true) {
  const { user } = useUser()

  const shouldFetch = isFetchAllowed && user && currencies?.length

  const keys = shouldFetch
    ? currencies.map(c => `/api/dashboard/customer/payment-methods/${c}`)
    : null

  const fetcher = (url: string) => baseFetcher(url)

  const { data } = useSWR(keys, async urls => {
    const results = await Promise.all(urls.map(fetcher))
    return results
  })

  return {
    data,
  }
}
